import { Component, inject } from '@angular/core';
import { SubscriptionErrorService } from '@app/core/services/subscription-error.service';

@Component({
  selector: 'app-subscription-error-banner',
  template: `
    @if (errors.bannerVisible()) {
      <div
        role="alert"
        class="pointer-events-auto flex max-w-xl items-start gap-3 rounded-lg border border-rose-700 bg-rose-950/95 px-4 py-3 shadow-lg shadow-rose-950/50"
      >
        <span aria-hidden="true" class="text-lg leading-none text-rose-300">&#9888;</span>
        <div class="flex flex-col gap-1 text-xs">
          <p class="text-sm font-semibold text-rose-100">
            AuditService.report() — your subscription died
          </p>
          <p class="font-mono text-rose-200">{{ errors.message() }}</p>
          <p class="text-rose-300">
            <code>error</code> is a terminal notification: RxJS delivers it instead of any further
            value, and the subscription is over either way. Handling it is how you find out why.
            Keep that material away from the method that threw — with a <code>filter()</code> — then
            subscribe again.
          </p>
        </div>
        <button
          type="button"
          class="ml-auto cursor-pointer rounded-md border border-rose-700 px-2 py-1 text-xs text-rose-200 hover:bg-rose-900"
          (click)="errors.dismiss()"
        >
          Dismiss
        </button>
      </div>
    }
  `,
  host: {
    class: 'pointer-events-none absolute inset-x-0 top-12 z-30 flex justify-center px-4',
  },
})
export class SubscriptionErrorBannerComponent {
  protected readonly errors = inject(SubscriptionErrorService);
}
